/*global $ */

import { backfaceFixed } from './backfaceFixed';

class GalleryModal {
  constructor() {
    this.$window = $(window);
    console.log('GalleryModal');
    this.$container = $('.GalleryModal');
    this.isOpen = false;

    this.$cards = [];

    this.$card = $('.GalleryModalCard');
    this.$parent = this.$card.parent();
    this.$thumb = this.$container.find('.GalleryModalCard__thumb');

    this.$container.find('.ProfileCard').each((i, e) => {
      this.$cards.push($(e));
    });

    $('.js-open-gallery-modal').on('click', (e) => {
      if (!this.isOpen) {
        console.log('open modal');
        this.fadein($(e.currentTarget).attr('data-src'));
      }
    });

    $('.BtnCloseGalleryModal').on('click', () => {
      if (this.isOpen) {
        this.fadeout();
      }
    });

    this.$window.on('resize', () => {
      this.onWindowResize();
    });
  }
  /*
    openOverlayPanel() {
      if (!this.isOpen) {
        this.isOpen = true;
        backfaceFixed(true);
      }
    }
    closeOverlayPanel() {
      if (this.isOpen) {
        this.isOpen = false;
        backfaceFixed(false);
      }
    }*/
  fadein(imgSrc) {
    console.log('fadein');
    if (!this.isOpen) {
      this.$thumb.empty();
      this.$thumb.append(`<img src="${imgSrc}" alt="">`);
      this.isOpen = true;
      backfaceFixed(true);
      /*
      for (let i = 0; i < this.$cards.length; i++) {
        if (this.$cards[i].attr('data-index') == index) {
          this.$cards[i].css('display', 'flex');
        } else {
          this.$cards[i].css('display', 'none');
        }
      }
      */
      this.$container.stop(false).css({
        opacity: 0,
        display: 'flex',
      });
      setTimeout(() => {
        this.onWindowResize();
        this.$container.animate({ opacity: 1 }, 400, 'easeOutSine', () => {});
      }, 30);
    }
  }
  fadeout() {
    if (this.isOpen) {
      this.isOpen = false;
      backfaceFixed(false);
      this.$container
        .stop(false)
        .animate({ opacity: 0 }, 400, 'easeOutExpo', () => {
          this.$container.css('display', 'none');
        });
    }
  }
  onWindowResize() {
    if (this.isOpen) {
      const parentWidth = this.$parent.width();
      const maxHeight = window.innerHeight - 200;
      let containerHeight = (parentWidth * 9) / 16;
      let containerWidth = parentWidth;

      if (containerHeight > maxHeight) {
        containerHeight = maxHeight;
        containerWidth = (containerHeight * 16) / 9;
      }
      this.$card.css({
        width: containerWidth,
        height: containerHeight,
      });
    }
  }
}

export default GalleryModal;
